var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"auth-card",attrs:{"max-width":"500","min-width":"400px"}},[_c('v-card-text',[_c('app-form',{ref:"form",attrs:{"model":_vm.model,"formErrors":_vm.formErrors,"loading":_vm.loading},on:{"submit":_vm.sendLoginRequest}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }